var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showPop,
          expression: "showPop"
        }
      ],
      attrs: { value: _vm.value }
    },
    [
      _c(
        "van-popup",
        {
          attrs: { position: "bottom", overlay: true },
          model: {
            value: _vm.showPop,
            callback: function($$v) {
              _vm.showPop = $$v
            },
            expression: "showPop"
          }
        },
        [
          _c("van-picker", {
            attrs: {
              "show-toolbar": "",
              columns: _vm.pickerList,
              "value-key": "name"
            },
            on: {
              confirm: _vm.typeChange,
              cancel: function($event) {
                _vm.showPop = !_vm.showPop
              }
            },
            model: {
              value: _vm.types,
              callback: function($$v) {
                _vm.types = $$v
              },
              expression: "types"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4619d608", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4619d608","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/active/component/allActive.vue
// module id = null
// module chunks = 